import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ZoneService } from '../../../../../services/zone.service';
import { Validation } from '../../../error/error-messages/validator-messages';
import { TripExpenseService } from '../../../../../services/tripExpense.service';
import Swal from 'sweetalert2';
import { TripExpense } from '../../../../../models/tripExpense.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tripe-expense',
  templateUrl: './tripe-expense.component.html',
  styleUrls: ['./tripe-expense.component.scss']
})
export class TripeExpenseComponent implements OnInit {

  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton2') closebutton2;

  // @ts-ignore
  tripExpense: TripExpense[] = [];
  // @ts-ignore
  tripExpenseTmp: TripExpense[] = [];
  // @ts-ignore
  currentTripExpense: TripExpense = [];
  // @ts-ignore
  zone: IZone[] = [];

  desactiveSubmitButton: boolean = false;

  search: any;
  page = 0;
  perPage = 10;
  /*
  end for all page
   */
  sorted = false;
  sorted1 = false;
  sorted2 = false;
  sorted3 = false;

  constructor(private fb: FormBuilder, private tripExpenseService: TripExpenseService,
              private router :Router, private zoneService: ZoneService) { }

  ngOnInit(): void {
    this.loadTripExpense();
    this.loadZones();
  }

  get f() { return this.tripExpenseForm.controls; }
  get f1() { return this.editTripExpenseForm.controls; }

  tripExpenseForm = this.fb.group({
    default_price: new FormControl('', [ Validation.requiredValidator("Le prix par défaut"),]),
    zone: new FormControl('', [ Validation.requiredValidator("La zone"),]),
  });

  editTripExpenseForm = this.fb.group({
    default_price: new FormControl('', [ Validators.required, Validators.minLength(2), Validators.pattern('^[0-9]+$')]),
    zone: new FormControl('', [ Validators.required]),
  });

  loadTripExpense = () => {
    this.tripExpenseService.getTripExpense().subscribe(data => {
        //console.log(data);
        this.tripExpense = data
        this.tripExpenseTmp = data
      }, (err) => {
       // console.log('-----> err', err);
      });
  }

  loadZones = () => {
    this.zoneService.getZone()
      .subscribe(data => {
        this.zone = data;
      }, (err) => {
        // console.log('-----> err', err);
      });
  }

  onTripExpenseFormSubmit() {
    this.desactiveSubmitButton = true;
    //console.log(this.tripExpenseForm.value);
    const tripExpense: TripExpense = this.tripExpenseForm.value;
    this.zoneService.getIdZone(this.tripExpenseForm.controls['zone'].value).subscribe(
      data => {
        tripExpense.zone = data;
        this.tripExpenseService.saveTripExpense(tripExpense).subscribe(rs => {
        //  console.log(rs);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Les Frais de déplacement ont été ajoutés avec succès"',
            showConfirmButton: false,
            timer: 1500
          });
          this.desactiveSubmitButton = false;
          this.loadTripExpense();
          this.close();
          this.reloadComponent();
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Veuillez vérifier les données : ' + error.error.errorMessage,
            showConfirmButton: false,
            timer: 2500
          });
          this.desactiveSubmitButton = false;
        });
      }
    );
  }

  reloadComponent() {
    let currentUrl = this.router.url;
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([currentUrl]);
  }

  deleteTripExpense(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer ces frais de déplacements ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.tripExpenseService.deleteTripExpense(id).subscribe(
          rs => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Les frais de déplacement ont été supprimés avec succès"',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadTripExpense();
          }, error => {
           // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 2500
            });
            this.loadTripExpense();
          }
        );
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',

        })
      }
    });
  }

  onEditTripExpense(id: any) {
    this.tripExpenseService.getIdTripExpense(id).subscribe(rs => {
      this.currentTripExpense = rs;
      this.editTripExpenseForm = this.fb.group({
        id: new FormControl(this.currentTripExpense.id, [ ]),
        default_price: new FormControl(this.currentTripExpense.default_price, [ Validators.required, Validators.minLength(2), Validators.pattern('^[0-9]+$')]),
        zone: new FormControl(this.currentTripExpense.zone, [ Validators.required] ),
      });
      // @ts-ignore
      this.editTripExpenseForm.get('zone').setValue(this.currentTripExpense.zone?.id);
    });
  }

  onEditTripExpenseFormSubmit() {
   // console.log(this.editTripExpenseForm.value);
    const tripExpense: TripExpense = this.editTripExpenseForm.value;
    this.zoneService.getIdZone(this.editTripExpenseForm.controls['zone'].value).subscribe(
      data => {
        tripExpense.zone = data;
        this.tripExpenseService.updateTripExpense(tripExpense).subscribe(rs => {
          //console.log(rs);
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Les frais de déplacement ont été modifiés avec succés"',
            showConfirmButton: false,
            timer: 1500
          });
          this.close();
          this.loadTripExpense();
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Veuillez vérifier les données',
            showConfirmButton: false,
            timer: 2500
          });
        });
      }
    );

  }

  onViewTripExpense(id: any) {
    this.tripExpenseService.getIdTripExpense(id).subscribe(rs => {
      this.currentTripExpense = rs;
    });
  }

  displayPerPage(value: any) {
    this.perPage = parseInt(value, 10);
   // console.log(this.perPage);
  }

  // searchFilter($event: KeyboardEvent) {
  //   console.log(this.search);
  //   this.tripExpense = this.tripExpenseTmp.filter(value =>
  //     value.zone?.name?.toUpperCase().includes(this.search) || value.zone?.name?.toLowerCase().includes(this.search)
  //     || value?.default_price === this.search
  //   );
  // }

  searchFilter($event: KeyboardEvent) {
   // console.log(this.search);
    const searchTerm = (this.search as string).toUpperCase();
    this.tripExpense = this.tripExpenseTmp.filter(value =>
      (value.zone?.name && value.zone.name.toUpperCase().includes(searchTerm)) ||
      (value.default_price && value.default_price.toString() === searchTerm)
    );
  }



  sort1() {
    if (this.sorted1 == false) {
      // @ts-ignore
      this.tripExpense.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      this.sorted1 = true;
    } else {
      // @ts-ignoe
      this.sorted1 = false;
    }
  }

  sort2() {
    if (this.sorted2 == false) {
      // @ts-ignore
      this.tripExpense.sort((a, b) => a.default_price > b.default_price ? 1 : a.default_price < b.default_price ? -1 : 0);
      this.sorted2 = true;
    } else {
      // @ts-ignore
      this.tripExpense.sort((a, b) => a.default_price < b.default_price ? 1 : a.default_price > b.default_price ? -1 : 0);
      this.sorted2 = false;
    }
  }

  sort3() {
    if (this.sorted3 == false) {
      // @ts-ignore
      this.tripExpense.sort((a, b) => a.zone?.name > b.zone?.name ? 1 : a.zone?.name < b.zone?.name ? -1 : 0);
      this.sorted3 = true;
    } else {
      // @ts-ignore
      this.tripExpense.sort((a, b) => a.zone?.name < b.zone?.name ? 1 : a.zone?.name > b.zone?.name ? -1 : 0);
      this.sorted3 = false;
    }
  }

  close() {
    this.closebutton.nativeElement.click();
    this.closebutton2.nativeElement.click();
  }

}
